import template from './edit.html';
import controller from './edit.controller';

const EditPickupPointComponent = {
  bindings: {
    mode: '@', // 'create', 'edit' (needs a product object)
    pickupPoint: '=?',
    vasId: '=?',
    onCancel: '&'
  },
  template,
  controller
};

export default EditPickupPointComponent;



/** WEBPACK FOOTER **
 ** ./client/app/components/services/orderAndPay/pickupPoint/edit/edit.component.js
 **/